<template>
  <v-dialog
    :value="show"
    @input="$emit('update:show', $event)"
    max-width="450"
    persistent
  >
    <v-card rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold pb-1">
        <v-icon color="teal" class="mr-2" small>mdi-content-save</v-icon>
        Save as Template
      </v-card-title>
      <v-card-text class="pt-4">
        <v-text-field
          v-model="templateName"
          label="Template Name"
          placeholder="e.g. Standard Desktop PC"
          outlined
          dense
          autofocus
          prepend-inner-icon="mdi-label"
        ></v-text-field>

        <v-textarea
          v-model="templateDescription"
          label="Description (optional)"
          placeholder="Describe this template for future reference..."
          outlined
          dense
          rows="2"
          auto-grow
          prepend-inner-icon="mdi-text"
        ></v-textarea>

        <div v-if="bundle" class="caption grey--text text--darken-1">
          This will save {{ bundle.items.length }} item{{
            bundle.items.length !== 1 ? "s" : ""
          }}
          from "{{ bundle.name }}" as a reusable template.
        </div>
      </v-card-text>

      <v-card-actions class="px-6 pb-4">
        <v-spacer></v-spacer>
        <v-btn text class="text-none" @click="close">Cancel</v-btn>
        <v-btn
          color="teal"
          depressed
          dark
          class="text-none"
          :disabled="!templateName.trim()"
          :loading="saving"
          @click="save"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Save Template
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    bundle: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      templateName: "",
      templateDescription: "",
      saving: false,
    };
  },
  watch: {
    show(val) {
      if (val && this.bundle) {
        this.templateName = this.bundle.name || "";
        this.templateDescription = "";
      }
    },
  },
  methods: {
    ...mapActions({
      addTemplate: "bundle_template/add_bundle_template",
    }),
    close() {
      this.$emit("update:show", false);
    },
    async save() {
      if (!this.bundle || !this.templateName.trim()) return;
      this.saving = true;
      try {
        const payload = {
          name: this.templateName.trim(),
          bundle_type: this.bundle.type || "Custom",
          description: this.templateDescription || null,
          items: this.bundle.items.map((item, idx) => ({
            item_type: item.item_type,
            item_name: item.item_name,
            quantity: item.quantity,
            unit: item.unit,
            supplier: item.supplier,
            supplier_price: item.supplier_price,
            is_vat: item.is_vat,
            freight_in_per_unit: item.freight_in_per_unit,
            sort_order: idx,
          })),
        };
        await this.addTemplate(payload);
        this.$emit("saved");
        this.close();
      } catch (err) {
        console.error("Failed to save template:", err);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
